import { MdClose } from 'react-icons/md';
import useParamsEditor from '@/src/utils/useParamsEditor';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

export default function Modal({
  children,
  backgroundClose = true,
  customClose,
  theme = 'black',
  width = true,
}: {
  children: React.ReactNode;
  backgroundClose?: boolean;
  customClose?: () => any;
  theme?: 'black' | 'yellow';
  width?: number | boolean;
}) {
  const t = useTranslations('Modal');
  const editParam = useParamsEditor();
  const close = () => {
    if (customClose) {
      customClose();
    } else {
      editParam('modal');
    }
  };
  const backdropClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!backgroundClose) {
      return;
    }
    if ((e.target as Element).classList.contains('backdropClick')) {
      close();
    }
  };

  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);

  const styles = width && width !== true ? { maxWidth: width + 'px' } : {};

  return (
    <div
      onClick={(e) => backdropClick(e)}
      className={`${backgroundClose ? 'backdropClick' : ''}
      fixed inset-0 z-50 flex overflow-y-scroll bg-opacity-80 px-6 py-14 backdrop-blur`}
    >
      <div
        className={`relative mx-auto my-auto ${
          width === true ? 'w-full max-w-[800px]' : ''
        }`}
        style={styles}
      >
        <button
          type='button'
          onClick={close}
          className={`${theme === 'black' ? 'text-white' : 'text-black'} absolute right-4 top-4 cursor-pointer rounded-sm text-3xl font-bold transition-all hover:bg-brand hover:text-dark`}
        >
          <span className='sr-only'>{t('ariaCloseButton')}</span>
          <MdClose />
        </button>
        <div
          className={`${theme === 'black' ? 'border-brand bg-black' : 'border-black bg-brand'} font-white rounded-lg border p-12 shadow-2xl shadow-brand/20`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
